function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { communityContentQueryPage, communityContentDeleteByIds, communityContentUpdateById, communityQuestionExamineUpdateById } from '@/api/community/community';
import addDynamic from './components/addDynamic';
import addManagemen from './components/addManagemen';
import { parseTime } from '@/utils';
import { downloadFile2 } from '@/utils/download';
import { languageType, contentType } from '@/utils/enum';
export default {
  name: 'CommunityDynamicHome',
  components: {
    addDynamic: addDynamic,
    addManagemen: addManagemen
  },
  data: function data() {
    return {
      languageType: languageType,
      contentType: contentType,
      dnamicSelect: [{
        value: '',
        label: '全部'
      }, {
        value: 1,
        label: '是'
      }, {
        value: 0,
        label: '否'
      }],
      typeSelect: [{
        value: '',
        label: '全部'
      }, {
        value: 1,
        label: '动态'
      }, {
        value: 2,
        label: '问答'
      }],
      creatorFlagList: [{
        value: '',
        label: '全部'
      }, {
        value: 1,
        label: '是'
      }, {
        value: 0,
        label: '否'
      }],
      auditStatusList: [{
        value: '',
        label: '全部'
      }, {
        value: 0,
        label: '未审核'
      }, {
        value: 1,
        label: '审核通过'
      }, {
        value: 2,
        label: '审核未通过'
      }, {
        value: 3,
        label: '仅我可见'
      }],
      value: '',
      input: '',
      elementui_page_component_key: 0,
      tableFrom: {
        page: 1,
        limit: 20,
        keyword: '',
        memberName: '',
        selfFlag: '',
        topFlag: '',
        memberVirtualFlag: '',
        // 虚拟用户
        type: '',
        contentType: '',
        language: '',
        // 语言
        showEnable: '',
        creatorFlag: '',
        // 创作者
        auditStatus: '' // 审核状态
        // keywords: ''

      },
      listLoading: false,
      listData: {
        list: [],
        total: 0
      },
      multipleSelection: [],
      form: {
        id: 0,
        auditStatus: 1
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var screening, url;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.$route.params.screening) {
                screening = _this.$route.params.screening;
                _this.tableFrom = Object.assign(_this.tableFrom, screening);
                _this.elementui_page_component_key++;
              } else {
                url = window.location.href; // 获取当前页面的url

                if (url.indexOf('?') !== -1) {
                  // 判断是否存在参数
                  url = url.replace(/(\?|#)[^'"]*/, ''); // 去除参数

                  window.history.pushState({}, 0, url);
                }
              }

              _context.next = 3;
              return _this.getList();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    downloadFile2: downloadFile2,
    parseTime: parseTime,
    httpzhttps: function httpzhttps(url) {
      console.log(url);
      var httpsUrl = url.replace("http://", "https://");
      console.log(httpsUrl);
      return httpsUrl;
    },
    deleteRow: function deleteRow(index, rows) {
      this.$message.error('暂未开发!');
      return; // rows.splice(index, 1)
    },
    lookRow: function lookRow() {
      this.$message.error('暂未开发!');
    },
    handlerScreen: function handlerScreen() {
      this.tableFrom.page = 1;
      this.tableFrom.limit = 20;
      this.getList();
    },
    // 打开弹窗
    addManagemen: function addManagemen(row) {
      var _this2 = this;

      // 重置弹窗
      this.$refs.addManagemen.setting.visible = true;
      this.$nextTick().then(function () {
        _this2.$refs.addManagemen.tableFrom.communityContentId = row.id;
        _this2.$refs.addManagemen.memberId = row.createBy;
      });
    },
    handleReset: function handleReset() {
      this.tableFrom.page = 1;
      this.tableFrom.limit = 20;
      this.tableFrom.keyword = '';
      this.tableFrom.memberName = '';
      this.tableFrom.showEnable = '';
      this.tableFrom.topFlag = '';
      this.tableFrom.type = '';
      this.tableFrom.language = '';
      this.tableFrom.selfFlag = '';
      this.tableFrom.contentType = '';
      this.tableFrom.memberVirtualFlag = '';
      this.getList();
    },
    // table 选中行回调
    handleSelectionChange: function handleSelectionChange(row) {
      var arr = [];
      row.map(function (item) {
        arr.push(item.id);
      });
      this.multipleSelection = arr;
    },
    // 打开弹窗
    addCelebrity: function addCelebrity() {
      // 重置弹窗
      this.$refs.addDynamic.formModal = {
        createBy: '',
        // 发布人
        contentType: '',
        // 分类
        topicId: '',
        // 话题
        title: '',
        // 标题
        content: '',
        // 内容
        image: '',
        // 图片
        video: '',
        // 视频
        videoDuration: '',
        // 视频总时长
        videoAspectRatioType: '',
        // 视频宽屏 类型
        videoAspectRatio: '',
        // 视频比例
        url: [],
        // 超链接
        likeNum: '',
        // 点赞数
        discussNum: '',
        // 评论数
        forwardNum: '',
        // 转发数
        selfFlag: 0,
        // 自营
        topFlag: 0,
        // 置顶
        showEnable: true,
        // 状态
        auditStatus: '1',
        // 审核通过
        topicList: [],
        memberName: ''
      };
      this.$refs.addDynamic.setting.visible = true;
    },
    handlerState: function handlerState(statue, val) {
      var formDisable = '0';
      var formModal = {
        id: val.id,
        // id
        createBy: '',
        // 发布人
        contentType: '',
        // 分类
        title: '',
        // 标题
        topicId: '',
        // 话题
        content: '',
        // 内容
        image: '',
        // 图片
        video: '',
        // 视频
        videoDuration: '',
        // 视频总时长
        videoAspectRatioType: '',
        // 视频宽屏 类型
        videoAspectRatio: '',
        // 视频比例
        url: [],
        // 超链接
        likeNum: '',
        // 点赞数
        selfFlag: 0,
        // 自营
        topFlag: 0,
        // 置顶
        discussNum: '',
        // 评论数
        forwardNum: '',
        // 转发数
        showEnable: true,
        // 状态
        memberName: '',
        type: 1,
        // 动态类型 1 动态 2 问答
        auditStatus: 1,
        // 审核通过
        topicList: [],
        currencyId: '',
        // 币种id
        language: 'cn',
        // 默认简体
        currencyList: [] // 币种列表

      };

      if (statue === 3) {
        formDisable = '1'; // 禁止编辑状态
      }

      if (statue !== 1) {
        formModal = val;
      }

      this.$router.push({
        name: 'AddCommunity',
        query: {
          statue: statue,
          // 状态1 新增 2 编辑 3 查看
          formModal: encodeURIComponent(JSON.stringify(formModal)),
          formDisable: formDisable
        },
        params: {
          screening: this.tableFrom
        }
      });
    },
    handlerDelete: function handlerDelete() {
      var _this3 = this;

      if (this.multipleSelection.length === 0) {
        this.$message.error('选中不能为空!');
        return;
      }

      var par = {
        ids: this.multipleSelection
      };
      communityContentDeleteByIds(par.ids).then(function (res) {
        _this3.$message.success('删除成功');

        _this3.getList();
      });
    },
    handleCut: function handleCut(row, key, value) {
      var _this4 = this;

      this.$confirm("\u786E\u8BA4".concat(row[key] ? '关闭' : '开启', "\u5F53\u524D").concat(value), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this4.setSave(row, key);
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: "\u5DF2\u53D6\u6D88".concat(row[key] ? '开启' : '关闭')
        });
      });
    },
    setSave: function setSave(row, key) {
      var _this5 = this;

      row[key] = row[key] ^ 1;
      communityContentUpdateById(row).then(function (res) {
        _this5.$message.success('修改成功');
      }).catch(function (res) {
        row[key] = row[key] ^ 1;

        _this5.$message.error('修改失败');
      });
    },
    handlerStatus: function handlerStatus(rowData) {
      var _this6 = this;

      var status = rowData.auditStatus;
      var prm = {
        id: rowData.id
      };

      if (status === 0) {
        this.$confirm("\u662F\u5426\u5BA1\u6838\u901A\u8FC7", '提示', {
          confirmButtonText: '通过',
          cancelButtonText: '不通过',
          type: 'warning'
        }).then(function () {
          prm.auditStatus = 1;

          _this6.changeAudit(prm);
        }).catch(function () {
          prm.auditStatus = 2;

          _this6.changeAudit(prm);
        });
      } else if (status === 1 || status === 2 || status === 3) {
        prm.auditStatus = 0;
        this.changeAudit(prm);
      }
    },
    changeAudit: function changeAudit(prm) {
      var _this7 = this;

      communityContentUpdateById(prm).then(function (res) {
        _this7.$message.success("\u5BA1\u6838".concat(prm.status === 1 ? '通过' : '不通过'));

        _this7.getList();
      });
    },
    // 列表
    getList: function getList() {
      var _this8 = this;

      this.listLoading = true;
      communityContentQueryPage(this.tableFrom).then(function (res) {
        _this8.listData.list = res.list;
        _this8.listData.total = res.totalCount;
        _this8.listLoading = false;
      }).catch(function () {
        _this8.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      console.log('发生改变', page);
      this.tableFrom.page = page;
      this.multipleSelection = [];
      this.$refs.multipleTable.clearSelection();
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.tableFrom.limit = val;
      this.getList();
    },
    updAuditStatus: function updAuditStatus(id, status) {
      var _this9 = this;

      this.form.id = id;

      if (status === 0) {
        this.$confirm("\u662F\u5426\u5BA1\u6838\u901A\u8FC7", '提示', {
          confirmButtonText: '通过',
          cancelButtonText: '不通过',
          type: 'warning'
        }).then(function () {
          _this9.form.auditStatus = 1;
          communityQuestionExamineUpdateById(_this9.form).then(function (res) {
            _this9.getList();

            _this9.$message.success('修改成功');
          }).catch(function () {
            _this9.$message.success('修改失败');
          });
        }).catch(function () {
          _this9.form.auditStatus = 2;
          communityQuestionExamineUpdateById(_this9.form).then(function (res) {
            _this9.getList();

            _this9.$message.success('修改成功');
          }).catch(function () {
            _this9.$message.success('修改失败');
          });
        });
      } else if (status === 1 || status === 2 || status === 3) {
        this.form.auditStatus = 0;
        communityQuestionExamineUpdateById(this.form).then(function (res) {
          _this9.getList();

          _this9.$message.success('修改成功');
        }).catch(function () {
          _this9.$message.success('修改失败');
        });
      }
    }
  }
};